import React from "react";
import { Button, Tooltip } from "antd";
import { CloseOutlined } from "@ant-design/icons";

const ModalCloseButton = (props) => {
  const { closeModal } = props;
  return (
    <Tooltip title="search">
      <Button
        onClick={closeModal}
        size="large"
        style={{ position: "absolute", right: 10, top: 10 }}
        // type="text"
        shape="circle"
        icon={<CloseOutlined />}
      />
    </Tooltip>
  );
};

export default ModalCloseButton;
